import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { observer } from "mobx-react";
import { HStack, Stack } from "@chakra-ui/react";
import { Clients } from "../Clients";
// import { Admins } from "../Admins";
import { Reports } from "../Reports";
import { ClientDetail } from "../ClientDetail";
import { Sidebar } from "../../components/Sidebar";
import { AdminSettings } from "../AdminSettings";
import { useStores } from "../../hooks/useStores";

export const AdminLayout: React.FC = observer(() => {
  const { session } = useStores();

  useEffect(() => {
    session.getSettings();
  }, []);

  return (
    <HStack display="flex" flex={1} flexDirection="row" height="100vh">
      <Sidebar />
      <Stack height={"100vh"} overflowY={"scroll"} flexGrow={2}>
        <Route exact path={"/admin/clients"} component={Clients} />
        {/* <Route path={"/admin/admins"} component={Admins} /> */}
        <Route exact path={"/admin/reports"} component={Reports} />
        <Route path={"/admin/settings"} component={AdminSettings} />
        <Route path={"/admin/clients/:userId"} component={ClientDetail} />
      </Stack>
    </HStack>
  );
});
